import { Menu } from '@nimbus-ds/patterns';
import classNames from 'classnames';
import { useDesktopMenuContext } from 'App/components/Menu/DesktopMenuProvider';
import HelpMenuContent from './components/HelpMenuContent';

interface AccountMenuProps {
  visible: boolean;
  onClose: () => void;
}

function HelpMenu({ visible, onClose }: Readonly<AccountMenuProps>) {
  const { isExpandedMenu } = useDesktopMenuContext();

  return (
    <div
      className={classNames('stratus--menu-container', 'stratus--submenu', {
        visible,
      })}
    >
      <Menu expanded={isExpandedMenu}>
        <HelpMenuContent onClose={onClose} />
      </Menu>
    </div>
  );
}

export default HelpMenu;
